import { render, staticRenderFns } from "./BaseIndicator.vue?vue&type=template&id=657a7aff"
import script from "./BaseIndicator.vue?vue&type=script&lang=js"
export * from "./BaseIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports